
let indent2em = function (tinymce) {
  (function () {
    'use strict'

    let global = tinymce.util.Tools.resolve('tinymce.PluginManager')
    let global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools')

    let doIndent2em = function (editor) {
      let dom = editor.dom
      let blocks = editor.selection.getSelectedBlocks()
      let act = ''
      let indent2emVal = editor.getParam('indentVal', '2em')
      global$1.each(blocks, function (block) {
        if (act === '') {
          act = dom.getStyle(block, 'text-indent') === indent2emVal ? 'remove' : 'add'
        }
        if (act === 'add') {
          dom.setStyle(block, 'text-indent', indent2emVal)
        } else {
          let style = dom.getAttrib(block, 'style')
          style = style.replace(/text-indent:[\s]*2em;/ig, '')
          dom.setAttrib(block, 'style', style)
        }
      })
    }

    let register = function (editor) {
      editor.addCommand('doIndent2em', function () {
        doIndent2em(editor)
      })

      editor.addButton('indent2em', {
        tooltip: '首行缩进',
        image: 'https://jty-open-new.obs.cn-north-4.myhuaweicloud.com/2024/2024-9-9/1725870579113ho0yjj52u.png',
        icon: false,
        cmd: 'doIndent2em'
      })

      editor.addMenuItem('indent2em', {
        text: '首行缩进',
        image: 'https://jty-open-new.obs.cn-north-4.myhuaweicloud.com/2024/2024-9-9/1725870579113ho0yjj52u.png',
        icon: false,
        cmd: 'doIndent2em'
      })
    }

    global.add('indent2em', function (editor) {
      register(editor)
    })

    function Plugin () {}

    return Plugin
  })()
}

export default indent2em



// WEBPACK FOOTER //
// ./src/components/editor4/tinymce/plugins/indent2em/index.js